module.exports = __webpack_public_path__ + "static/images/icon-harpercollins.33bb11f958d25f551b421aad17177d75.svg";